module.exports = __webpack_public_path__ + "media/images/wedding/top/wedding-og-image-ef4d6decd621619852203fe723d0e87f.png";